import { Text, View } from "@react-pdf/renderer";

type PropertyGridProps = { properties: Record<string, string | null> };

const PropertyGrid: React.FC<PropertyGridProps> = (props) => {
  const { properties } = props;

  return (
    <View style={{ display: "flex", flexDirection: "row", gap: 10, fontSize: 10 }}>
      <View style={{ display: "flex", flexDirection: "column", rowGap: 5 }}>
        {Object.entries(properties).map(
          ([key, value], index) =>
            !!value && (
              <Text key={index} style={{ fontWeight: "bold" }}>
                {key}:
              </Text>
            ),
        )}
      </View>

      <View style={{ display: "flex", flexDirection: "column", rowGap: 5 }}>
        {Object.values(properties).map(
          (value, index) => !!value && <Text key={index}>{value}</Text>,
        )}
      </View>
    </View>
  );
};

export default PropertyGrid;
